import VgsiSolutions from './view/vgsiSolutions.vue'
import geb from 'vue-geb'
import Vue from 'vue'

Vue.use(geb)
// Allow multiple Vue apps in the same page
const appElements = document.querySelectorAll('.vgsi-solutions')
appElements.forEach(element => {
  const solutions = JSON.parse(element.getAttribute('data-solutions'))
  const hotline = JSON.parse(element.getAttribute('data-hotline'))
  const more = JSON.parse(element.getAttribute('data-all'))
  /* eslint-disable no-new */
  let vm = new Vue({
    el: element,
    data: {
      solutions: null,
      hotline: null,
      more: null
    },
    render: h => h(VgsiSolutions)
  })
  // add data from atts
  vm.solutions = solutions
  vm.hotline = hotline
  vm.more = more
})
